import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonYpsiliLeft';
const args = {};

export class OligonYpsiliLeft extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
